export const toggle_tabs = (name) => ({
    type: "TOGGLE_TABS",
    name
});